export type WorkerConflictCode =
  | "worker_already_exists"
  | "worker_user_already_exists"
  | "worker_not_rehirable"
  | "worker_not_found_for_rehire"
  | "candidate_worker_collision";

const WORKER_CONFLICT_CODES: readonly WorkerConflictCode[] = [
  "worker_already_exists",
  "worker_user_already_exists",
  "worker_not_rehirable",
  "worker_not_found_for_rehire",
  "candidate_worker_collision",
];

function isWorkerConflictCode(value: unknown): value is WorkerConflictCode {
  return typeof value === "string" && (WORKER_CONFLICT_CODES as readonly string[]).includes(value);
}

function readCodeFromData(data: unknown): WorkerConflictCode | null {
  if (typeof data !== "object" || data === null) return null;
  const record = data as Record<string, unknown>;

  if (isWorkerConflictCode(record.code)) return record.code;

  const details = record.details;
  if (typeof details === "object" && details !== null && !Array.isArray(details)) {
    const detailCode = (details as Record<string, unknown>).code;
    if (isWorkerConflictCode(detailCode)) return detailCode;
  }
  if (Array.isArray(details)) {
    for (const entry of details) {
      if (typeof entry === "object" && entry !== null) {
        const entryCode = (entry as Record<string, unknown>).code;
        if (isWorkerConflictCode(entryCode)) return entryCode;
      }
    }
  }

  return null;
}

export function getWorkerConflictKey(error: unknown): string | null {
  if (typeof error !== "object" || error === null) return null;
  const data = (error as { data?: unknown }).data;
  const code = readCodeFromData(data);
  return code ? `errors.worker.${code}` : null;
}
